/// <amd-module name="VSS/Features/Markdown/Plugins/ImageTransformer" />
import * as MarkdownIt from "markdown-it";
import { IState } from "VSS/Features/Markdown/MarkdownIt";
import { MarkdownRendererOptions } from "VSS/Features/Markdown/MarkdownRendererContracts";
import * as Resources from "VSS/Features/Markdown/Resources";

export class ImageTransformer {
    private _options: MarkdownRendererOptions;
    private _defaultImageRenderer: MarkdownIt.TokenRender;

    constructor(md: MarkdownIt.MarkdownIt, options?: MarkdownRendererOptions) {
        this._options = options || {};

        // Save the default renderer and override this rule only for a certain condition [see _linkifyImageHandler]
        this._defaultImageRenderer = md.renderer.rules.image


        // If url transformer is passed in options, add the rule
        if (this._options.imageUrlTransformer) {
            md.core.ruler.push("image_links", (state) => this._linkTransformer(state));
        }

        if (this._options.linkifyImages && this._options.clickableImages) {
            md.renderer.rules.image = this._linkifyImageHandler;
        }
    }

    private _linkTransformer = (state: IState): void  => {
        // Run transformer on all top level tokens
        state.tokens.map(this._applyTransformerToHierarchy);
    }

    private _applyTransformerToHierarchy = (token: MarkdownIt.Token): void  => {
        if (token.children) {
            // If token has children, run transform recursively on all of them
            token.children.map(this._applyTransformerToHierarchy);
        }

        // If token is a image, apply the transform
        if (token.type === "image") {
            const src = token.attrGet("src");

            if (this._options.imageUrlTransformer && src) {
                const newSrc = this._options.imageUrlTransformer(src);
                token.attrSet("src", newSrc);
            }
        }
    }

    private _linkifyImageHandler = (tokens: MarkdownIt.Token[], index: number, options: any, env: any, self: any): string | void => {

        // Apply this transform only if img is not wrapped in <a></a>
        if (tokens[index-1] === undefined || tokens[index-1].type !== "link_open") {
            const token = tokens[index];
            const url = token.attrGet("src");
            const alt = token.attrGet("alt")

            return `<a href='${url}' target='_blank' aria-label='${Resources.OpenInNewWindow}'><img src='${url}' alt='${alt}'></a>`;
        }

        return this._defaultImageRenderer(tokens, index, options, env, self);
    }
}
